<template>
  <div class="new-page">
    <fetching-loader
      displayType="displayBlock"
      v-if="loadingPages"
    ></fetching-loader>
    <div v-else>
      <div class="input-textfield">
        <label for="pageTitle">Title</label>
        <input type="text" id="pageTitle" v-model="pageName" maxlength="50" />
      </div>

      <language-adaptive-select
        v-if="!$isSingleLanguage"
        @change="toggleLanguage"
        :languageTypes="languageTypes"
        :localLanguageTypesIndex="localLanguageTypesIndex"
      />

      <div class="input-group">
        <div class="input-textarea input-tiny">
          <label>Content</label>
          <HtmlEditor
            v-for="languageIndex in languageIndeces" 
            :key="languageIndex"
            v-show="languageIndex == localLanguageTypesIndex"
            v-model="contents[languageIndex]" 
            :unsetHeight="true"
          />
        </div>
      </div>

      <div class="button-container">
        <button class="button-neutral" @click="cancelPage">Cancel</button>
        <button class="button-positive" @click="addPage">Save</button>
      </div>
      <video-insert-input v-if="videoModal"></video-insert-input>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase";
import VideoInsertInput from "@/components/GlobalComponents/VideoInsertInput";
import newLanguageTypesFormatMixin from "@/mixins/newLanguageTypesFormatMixin";
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";
import HtmlEditor from "@/components/GlobalComponents/HtmlEditor";
import LanguageAdaptiveSelect from '@/components/Ui/LanguageAdaptiveSelect.vue';

export default {
  components: {
    VideoInsertInput,
    HtmlEditor,
    FetchingLoader,
    LanguageAdaptiveSelect
  },
  mixins: [newLanguageTypesFormatMixin],
  data() {
    return {
      pageName: "",
      showImageModal: false,
      contents: [],
      languageTypes: [],
      languageIndeces: [],
      videoModal: false,
      localLanguageTypesIndex: 0,
      loadingPages: true,
    };
  },
  async created() {
    this.localLanguageTypesIndex = await this._getLanguageIndex();
    this.languageTypes = await this._getCorrectEventLanguages();
    this.languageIndeces = new Array(this.languageTypes.length).fill().map((d,i)=>i);
    this.loadingPages = false;
  },
  methods: {
    addPage() {
      if (!this.pageName) {
        return alert("You must type a page name");
      }
      var newKey = db.ref(`/pages/${this.$customerId}/${this.$hotelId}/overview/`).push().key;
      let newPageObj = {
        name: this.pageName,
        path: "/pages/" + this.$hotelId + "/" + newKey,
        timestamp: new Date().getTime(),
      };

      // simultaneous write to database
      let batchUpdate = {};
      batchUpdate[`/${newKey}`] = this.contents;
      batchUpdate[`/overview/${newKey}`] = newPageObj;
      
      db.ref(`/pages/${this.$customerId}/${this.$hotelId}`)
        .update(batchUpdate)
        .then(() => {
          this.$toastEvents.push({
            type: "positive",
            title: "Pages",
            content: "Page has been added",
            id: +new Date(),
          });
          this.pageName = "";
          this.$router.push({ name: "list-pages" });
        });
    },
    cancelPage() {
      this.$router.push({ name: "list-pages" });
    },
    toggleLanguage(indexClicked) {
      this.localLanguageTypesIndex = Number(indexClicked);
    },
  },
};
</script>

<style scoped>
/* >>> Change the looks of Tiny MCE to fit in a little better <<< */
.input-group >>> .tox {
  border: 2px solid var(--grey);
  border-radius: var(--border-radius);
}

.input-tiny label {
  z-index: 2;
}

/* .contentCard {
  width: 80vw;
  margin: 0 auto;
  height: 100%;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
}

.buttonAddContainer {
  display: flex;
  justify-content: space-between;
}

.buttonAddContainer > input {
  padding: 15px 15px;
  color: #66615B;
  border-radius: 8px;
  border: 1px solid #707070;
  border-radius: 4px;
	outline: 0;
}

.pageOuterWrap, .pageLinkWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid var(--grey);
  border-radius: var(--border-radius);
  background-color: #FFFFFF;
  padding: 7px;
  margin: 10px;
  margin-bottom: 20px;
  height: 70px;
}
.pageTitleWrap {
  display: flex;
  margin-left: 10px;
}
.pageTitleWrap > input {
  padding: 10px 15px;
  width: 250px;
  color: #66615B;
  border: 2px solid var(--grey);
  border-radius: var(--border-radius);
	outline: 0;
  margin-left: 10px;
}
.pageTitleWrap > a {
  padding: 10px 15px;
  color: #66615B;
  margin-left: 20px;
}
.languagebarWrapper {
  margin-top: 10px;
  border: 2px solid var(--grey);
  border-radius: var(--border-radius);
}
.languageName {
  margin-left: 10px;
  font-size: 20px;
}
.pageTitleWrap > img {
  width: 50px;
  height: 50px;
}
.pageTitleWrap > p {
  margin-left: 20px;
}
.btnWrap {
  display: flex;
}
.btnWrap > div {
  margin-right: 10px;
}
.editorWrap {
  height: 700px;
  margin-top: 25px;
  padding: 10px;
}

select#langType {
  color: #707070;
  background-color: rgb(255, 255, 255);;
  font-weight: bold;
  border-radius: 4px;
  padding-left: 50px;
  width: 250px;
  height: 50px;
  margin-right: 20px;
}

.selectWrapper {
  position: relative;
}
.selectWrapper > img {
  position: absolute;
  width: 40px;
  top: 4px;
  left: 5px;
}
@media ( max-width: 890px) {
.pageOuterWrap {
  display: flex;
  flex-direction: column;
  height: auto;
}
.pageTitleWrap > img {
  display: none;
}
.btnWrap {
  margin-top: 15px;
  margin-bottom: 10px;
  margin-left: 20px;
  display: flex;
 }
.btnWrap > div {
  margin: 0;
 }
} */
</style>
